// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3478":"28f95132","7039":"28f95132","9257":"68e04cc7"}[chunkId] + ".chunk.css";
};